import React from "react";

import firebase from "firebase/compat/app";
import "firebase/compat/analytics";

import loadable from "@loadable/component";
import { Box } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { useRecoilValue } from "recoil";


import organizationIdState from "../../../atoms/organizationIdAtom";
import PageHeader from "../../../components/PageHeader";

const ProtocolsList = loadable(() => import("./protocols/ProtocolsList"));
const ProtocolDetail = loadable(() => import("./protocols/ProtocolDetail"));

const ProtocolsPage = () => {
  const organizationId = useRecoilValue(organizationIdState);

  // Exercise data is now managed by BigQuery system
  // No need to manually load exercises with React Query caching

  React.useEffect(() => {
    firebase.analytics().logEvent("page_view", {
      page_title: "Protocol Page",
      page_location: "/protocols",
    });
    firebase.analytics().logEvent("training_plans_v2_event", {
      eventName: "v1_opened",
      experimentKey: "training_plans_v2_parallel_adoption",
      entrypoint: "training_plans_v1",
      coachId: localStorage.getItem("uid") || "",
      organizationId: organizationId || "",
    });
  }, []);

  return (
    <>
      <PageHeader 
        title="Training Plans OLD" 
        subtitle="Legacy workout builder — create, customize, and manage your training protocols"
      />
      <Box sx={{ mt: 2.5, px: { xs: 2, sm: 3 } }}>
        <Routes>
          <Route path="" element={<ProtocolsList />} />
          <Route
            path="workout/:orgId/:protocolId"
            element={<ProtocolDetail />}
          />
        </Routes>
      </Box>
    </>
  );
};

export default ProtocolsPage;
